import { createElement, useState, useCallback, useEffect } from "react";
import './index.scss';
import { Wheel } from './wheel';
import classNames from "classnames";
const ColorfulPicker = function ColorfulPicker({ visible, columns, defaultValue, title, onConfirm, onChange, ...otherProps }) {
    const classPrefix = `au-picker`;
    const [isVisible, setIsVisible] = useState(false);
    const [innerValue, setInnerValue] = useState(defaultValue);
    const classString = classNames('au-picker-pane', {
        [`${classPrefix}-active`]: isVisible,
    });
    const _otherProps = otherProps || {};
    const handleSelect = useCallback((val, index) => {
        setInnerValue(prev => {
            const next = [...prev];
            next[index] = val;
            return next;
        });
    }, []);
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm(innerValue);
        }
        if (onChange) {
            onChange(innerValue);
        }
        setIsVisible(false);
    };
    useEffect(() => {
        setIsVisible(visible);
    }, [visible]);
    useEffect(() => {
        setInnerValue(defaultValue);
    }, [defaultValue]);
    return (createElement("div", { className: "au-select-picker" },
        createElement("div", { className: classString },
            createElement("div", { className: "au-mask" }),
            createElement("div", { className: classPrefix, ..._otherProps },
                createElement("div", { className: `${classPrefix}-header` },
                    createElement("a", { role: 'button', className: `${classPrefix}-header-button`, onClick: () => {
                            setIsVisible(false);
                        } }, "\u53D6\u6D88"),
                    createElement("div", { className: `${classPrefix}-header-title` }, title),
                    createElement("a", { role: 'button', className: `${classPrefix}-header-button`, onClick: () => {
                            handleConfirm();
                        } }, "\u786E\u5B9A")),
                createElement("div", { className: `${classPrefix}-body` },
                    createElement("div", { className: `${classPrefix}-view` },
                        columns?.map((column, index) => (createElement(Wheel, { key: index, index: index, column: column, value: innerValue[index], onSelect: handleSelect, mouseWheel: true }))),
                        createElement("div", { className: `${classPrefix}-mask` },
                            createElement("div", { className: `${classPrefix}-mask-top` }),
                            createElement("div", { className: `${classPrefix}-mask-middle` }),
                            createElement("div", { className: `${classPrefix}-mask-bottom` }))))))));
};
ColorfulPicker.displayName = 'ColorfulPicker';
export default ColorfulPicker;
